import React from 'react'
import PageHeader from '../../view/pageheader'
import { Button, Card, Form, Space, Flex, Tooltip, Popconfirm, Modal, Select, Input, Tag } from 'antd'
import { useState } from 'react';
import SearchComponent from '../CustomComponents/SearchComponent';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import TableComponent from '../CustomComponents/TableComponent';
import { addStationMaster, deleteStationMaster, getEventList, getStationMasterList, updateStationMaster, updateStationMasterStatus } from '../../store/reducer/eventSlice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import SwalComponent from '../CustomComponents/SwalComponent';

const { Option } = Select;
const StationMaster = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [editingStation, setEditingStation] = useState(null);
    const [stationFormModal, setStationFormModal] = useState(false);
    const { StationMasterListData, updateStaionMasterSuccess, updateStaionMasterError, updateStaionMasterErrorMessage, eventListData, deleteStationMasterSuccess, addStationMasterSuccess, addStationMasterErrorMessage, resetSuccessFlag, addStationMasterError,
        updateStationMasterStatusSuccess, updateStationMasterStatusError, updateStationMasterStatusErrorMessage
    } = useSelector((state) => state.events)
    const { count: stationMasterCount, data: stationMasterData } = StationMasterListData
    console.log(stationMasterData, "stationMasterData==");

    const { count: totalCount, data: tableData, eventIds } = eventListData;
    function getData(payload = {}) {
        dispatch(getEventList(payload));
        dispatch(getStationMasterList({ ...payload }))
    }
    useEffect(() => {
        getData();
    }, []);
    useEffect(() => {
        if (addStationMasterSuccess) {
            toast.success("Station Master added Successfully");
            getData(); // refresh list after add
            // toast.dismiss();
            // dispatch(resetSuccessFlag({ flag: "addStationMasterSuccess" }));
        }
        if (addStationMasterError) {
            toast.error(addStationMasterErrorMessage);
            // toast.dismiss();
            // dispatch(resetSuccessFlag({ flag: "addStationMasterError" }));
        }
        if (updateStaionMasterSuccess) {
            toast.success("Station Master updated Successfully");
            getData(); // refresh list after update
            // dispatch(resetSuccessFlag({ flag: "updateStaionMasterSuccess" }));
        }
        if (updateStaionMasterError) {
            toast.error(updateStaionMasterErrorMessage);
            // dispatch(resetSuccessFlag({ flag: "updateStaionMasterError" }));
        }
        if (deleteStationMasterSuccess) {
            getData();
            toast.success('Station Master Deleted Successfully')
        }
        if (updateStationMasterStatusSuccess) {
            toast.success("Station Master status updated Successfully");
            getData(); // refresh list after update

        }
        if (updateStationMasterStatusError) {
            toast.error(updateStationMasterStatusErrorMessage);
            // toast.dismiss();
            // dispatch(resetSuccessFlag({ flag: "updateStationMasterStatusError" }));
        }

    }, [
        addStationMasterSuccess,
        addStationMasterError,
        updateStaionMasterSuccess,
        updateStaionMasterError,
        deleteStationMasterSuccess,
        updateStationMasterStatusSuccess,
        updateStationMasterStatusError,
        updateStationMasterStatusErrorMessage,
        dispatch
    ]);
    // const handleDeleteStation = (id) => {
    //     dispatch(deleteStationMaster({ deleteID: id }));
    // };
    const stationColumns = [
        {
            title: "Stage Name",
            key: "stage_name",
            align: 'center',
            render: (record) => {
                const names = record?.station_master_key?.map(item => item.stage_name) || [];

                return names.length ? (
                    names.map((name, index) => (
                        <Tag color='purple' key={index}>
                            {name}
                        </Tag>
                    ))
                ) : (
                    "-"
                );
            }
        },
        {
            title: "Station Number",
            dataIndex: "station_number",
            key: "station_number",
        },
        {
            title: "Status",
            // dataIndex: "status",
            key: "status",
            render: record => (
                <SwalComponent
                    message="Are you sure you want to change the Station Master status?"
                    onClickDispatch={updateStationMasterStatus}
                    id={record.id}
                    status={true}
                    statusValue={record.status}
                    postData={{ status: record.status == 1 ? 0 : 1 }}
                />
            ),
        },
        {
            title: "Action",
            key: "action",
            align: "center",
            render: (record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button
                            shape="circle"
                            className="border-0"
                            icon={<EditOutlined style={{ color: "blue" }} />}
                            onClick={() => openEditModal(record)}
                        />
                    </Tooltip>

                    {/* <Popconfirm
                        title="Are you sure you want to delete this station?"
                        onConfirm={() => handleDeleteStation(record.id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button
                            shape="circle"
                            className="border-0"
                            icon={<DeleteOutlined style={{ color: "red" }} />}
                            danger
                        >

                        </Button>
                    </Popconfirm> */}
                </Space>
            ),
        },
    ];
    const [stageStatus] = useState([
        {
            label: "Active",
            value: 1,
        },
        {
            label: "Inactive",
            value: 0,
        },
    ]);
    const openEditModal = (record) => {
        setStationFormModal(true);
        setEditingStation(record);
        console.log(record, "record==");

        form.setFieldsValue({
            station_number: record.station_number,
            status: record.status,
            stage_id: record.station_master_key?.map(item => item.stage_id) || [], // ⬅ Convert to array
        });
    };

    const openAddStationModal = () => {
        setEditingStation(null);
        form.resetFields();
        setStationFormModal(true);
    };
    const handleStationMasterSubmit = () => {
        form.validateFields()
            .then((values) => {
                const stages = tableData.filter((e) => values.stage_id.includes(e.id));

                const payload = stages.map((item) => ({
                    stage_id: item.id,
                    stage_name: item.eventname,
                    station_number: values.station_number,
                }));
                if (editingStation) {
                    dispatch(updateStationMaster({ updateID: editingStation.id, postData: payload }));
                } else {
                    dispatch(addStationMaster({ postData: payload }));
                }

                setStationFormModal(false);
                form.resetFields();
                getData();
            })
            .catch((errorInfo) => {
                // AntD gives detailed error info here

                // toast.error("Please fill in all required fields before submitting.");
            });
    };
    return (
        <>
            <PageHeader HeaderText="Station Master" Breadcrumb={[{ name: "Station Master" }]} backButtonUrl="/events" />
            <Card
                title="Station Master"
                extra={
                    <>
                        <Space size={"middle"} className="my-3">
                            <SearchComponent

                                placeHolder="Search Station Number"
                                onChange={e => {
                                    const payloadData = {
                                        query: e.target.value
                                    };

                                    getData(payloadData);

                                }} />

                        </Space>

                        <Button icon={<PlusOutlined />} className="primary-btn ml-4" shape="round" onClick={openAddStationModal}>
                            Add Station Master
                        </Button>


                    </>
                }
            >

                <Flex justify="start"><div className="w-75">
                    {/* <Loader loading={userGroupLoading} /> */}
                    <TableComponent
                        columns={stationColumns}
                        dataSource={stationMasterData}
                        TotalDataCount={stationMasterCount}
                        onChangeDispatch={getData}
                        size={"small"}

                    /></div></Flex>
                <Modal
                    title={editingStation ? "Edit Station Master" : "Add Station Master"}
                    open={stationFormModal}
                    onCancel={() => setStationFormModal(false)}
                    onOk={handleStationMasterSubmit}
                    okText={editingStation ? "Update" : "Add"}
                >
                    <Form layout="vertical" form={form}>
                        <Form.Item
                            name="stage_id"
                            label="Select Event Stage"
                            rules={[{ required: true, message: "Please select Event stage" }]}
                        >
                            <Select mode="multiple" placeholder="Select Stage">
                                {tableData?.map((stage) => (
                                    <Option key={stage.id} value={stage.id}>
                                        {stage.eventname}
                                    </Option>
                                ))}

                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="station_number"
                            label="Station Number"
                            rules={[{ required: true, message: "Please enter station number" }]}
                        >
                            <Input
                                type="number"
                                placeholder="Enter Station Number"
                                onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key)) {
                                        e.preventDefault(); // block non-numeric keys
                                    }
                                }}
                            />
                        </Form.Item>
                        <Form.Item
                            name="status"
                            label="Status"
                            initialValue={stageStatus?.length > 0 ? stageStatus[0].value : 1}
                            rules={[{ required: true, message: "Please select status" }]}
                        >
                            <Select placeholder="Select Status">
                                {stageStatus.map((status) => (
                                    <Option key={status.value} value={status.value}>
                                        {status.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>



                    </Form>
                </Modal>
            </Card>

        </>
    )
}

export default StationMaster